<div class="bg-pattern w-full h-full flex flex-col items-center justify-center">
  <div [@fadeInUp] class="card overflow-hidden w-full max-w-md">
    <div class="p-6 pb-0 flex flex-col items-center justify-center">
      <div class="fill-current text-center">
        <img class="w-16" src="assets/img/logo/signet.svg" />
      </div>
    </div>

    <div class="text-center mt-4">
      <h2 class="title m-0">Reset Password</h2>
      <h4 class="body-2 text-secondary m-0">
        Enter your email for password recovery.
      </h4>
    </div>

    <div [formGroup]="form" class="p-6 flex flex-col">
      <mat-form-field>
        <mat-label>Email</mat-label>

        <mat-icon class="mr-2" matIconPrefix svgIcon="mat:mail"></mat-icon>
        <input formControlName="email" matInput required />
        <mat-error *ngIf="form.controls.email.hasError('required')">
          We can't recover your password, without your email.
        </mat-error>
        <mat-error *ngIf="form.controls.email.hasError('email')">
          Please provide a valid email address.
        </mat-error>
      </mat-form-field>

      <button
        (click)="sendPasswordResetEmail()"
        class="mt-2"
        color="primary"
        mat-raised-button
        type="button">
        SEND RECOVERY LINK
      </button>
    </div>
  </div>
</div>
